import { render, staticRenderFns } from "./aShopDetailSeckill.vue?vue&type=template&id=6c8a38e7&scoped=true"
import script from "./aShopDetailSeckill.vue?vue&type=script&lang=js"
export * from "./aShopDetailSeckill.vue?vue&type=script&lang=js"
import style0 from "./aShopDetailSeckill.vue?vue&type=style&index=0&id=6c8a38e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8a38e7",
  null
  
)

export default component.exports